export const VIDEO_STATE = /** @type {const} */ ({
  LOAD: 'LOAD',
  READY: 'READY',
  PLAY: 'PLAY',
  PAUSED: 'PAUSED',
  ENDED: 'ENDED',
  ERROR: 'ERROR',
});

/** @typedef {VIDEO_STATE[keyof typeof VIDEO_STATE]} VideoState */
